import RecipeInstructionsContainer from './recipe_instructions_container'

export default RecipeInstructionsContainer
